import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {ContentType} from '@deezer/next/services/types/contentType';
import type {SearchResult} from './types';
import type {AutocompleteEntity} from '@deezer/next/services/types/autocomplete';

const {get} = requestWrapper;

const requests = {
	searchAll: (queryString: string, searchType: string, requestId: string) =>
		get<AutocompleteEntity>(endpoints.searchAll, {
			requestId,
			params: {
				q: queryString,
				type: searchType || undefined,
			},
		}),
	searchItem: <T extends ContentType>(
		contentType: T,
		queryString: string,
		requestId: string,
		params?: object,
	) =>
		get<SearchResult<T>>(endpoints.searchItem(contentType), {
			requestId,
			params: {
				...params,
				q: queryString,
			},
		}),
};

export default requests;
